import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'Inclusione Facile (BES/DSA)',
  price: '€47',
  desc: 'Mappe, PDP template e materiali compensatori pronti per ogni unità. Zero stress con la Legge 170/2010.'
}, {
  num: '2',
  title: 'Excel Automatico per Docenti',
  price: '€67',
  desc: 'Fogli di calcolo che correggono bilanci e verifiche al posto tuo. Inserisci i dati, il file fa il resto.'
}, {
  num: '3',
  title: 'Ed. Civica & Economia Reale',
  price: '€47',
  desc: '20 unità collegate alla Costituzione economica. Le 33 ore obbligatorie già pianificate per te.'
}, {
  num: '4',
  title: 'Registro Veloce',
  price: '€37',
  desc: 'Griglie pronte per ClasseViva, Argo e Axios. Il tuo weekend torna ad essere tuo.'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-12 px-4 relative overflow-hidden" data-id="element-30">
      <div className="absolute inset-0 bg-brand-orange/5 blur-[120px] rounded-full max-w-3xl mx-auto" data-id="element-31" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 flex flex-col items-center" data-id="element-33">
          <div className="bg-brand-orange/20 p-4 rounded-full mb-4" data-id="element-34">
            <GiftIcon className="w-10 h-10 text-brand-orange" data-id="element-35" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream" data-id="element-36">
            4 Bonus Strategici <span className="text-brand-gold" data-id="element-37">Inclusi</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-38">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-br from-brand-card to-[#2a1810] border border-brand-orange/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_20px_rgba(249,115,22,0.1)]" data-id="element-39">
              <div className="flex items-start justify-between gap-3 mb-4" data-id="element-40">
                <div className="flex items-center gap-3" data-id="element-41">
                  <span className="text-2xl" data-id="element-42">📗</span>
                  <h3 className="text-lg sm:text-xl font-bold text-brand-gold leading-tight" data-id="element-43">
                    Bonus {bonus.num} — {bonus.title}
                  </h3>
                </div>
                <span className="text-brand-orange font-black text-base shrink-0" data-id="element-44">
                  {bonus.price}
                </span>
              </div>
              <p className="text-gray-300 font-medium leading-relaxed" data-id="element-45">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 text-center bg-brand-card border border-brand-gold/40 rounded-2xl py-4 px-5" data-id="element-46">
          <p className="text-brand-cream font-black text-base sm:text-lg" data-id="element-47">
            💎 VALORE TOTALE DEI 4 BONUS:{' '}
            <span className="text-brand-gold" data-id="element-48">€198</span>
          </p>
        </motion.div>
      </div>
    </section>;
}